var SculpteoSlicerRedraw = function (
  canvas,
  interiorColor,
  contourColor,
  contourWidth,
  interiorPathsColor,
  interiorPathsWidth,
  errorPointColor
) {
  var pointTransform = function (x, y, scale, origin) {
    var _p = [x - origin[0], y - origin[1]];

    _p[0] *= 1 / scale;
    _p[1] *= 1 / scale;

    // Transformation to take into account
    // the origin on the top left
    // of the canvas
    _p[1] = 1 - _p[1];

    return _p;
  };

  var buildSlicePath = function (slice, w, h, origin, scale, close) {
    var path = new Path2D();

    for (var j = 0; j < slice.length; j++) {
      var polygon = slice[j];
      var p = pointTransform(polygon[0], polygon[1], scale, origin);

      path.moveTo(p[0] * w, p[1] * h);

      for (var k = 2; k < polygon.length; k += 2) {
        var p = pointTransform(polygon[k], polygon[k + 1], scale, origin);

        path.lineTo(p[0] * w, p[1] * h);
      }

      if (close) {
        path.closePath();
      }
    }

    return path;
  };

  var buildErrorPoint = function (pt, w, h, origin, scale) {
    var p = pointTransform(pt[0], pt[1], scale, origin);
    var path = new Path2D();

    path.arc(p[0] * w, p[1] * h, 2.0, 0, 2 * Math.PI, 1);

    return path;
  };

  var buildSliceCanvas = function (
    slice,
    w,
    h,
    zoom,
    origin,
    scale,
    errList,
    interiorPaths
  ) {
    var canvas = document.createElement("canvas");

    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext("2d");

    ctx.fillStyle = interiorColor;
    var path = buildSlicePath(slice, w * zoom, h * zoom, origin, scale, true);

    ctx.fill(path);
    ctx.strokeStyle = interiorPathsColor;
    ctx.lineWidth = interiorPathsWidth;
    var path2 = buildSlicePath(
      interiorPaths,
      w * zoom,
      h * zoom,
      origin,
      scale,
      true
    );

    ctx.stroke(path2);
    ctx.strokeStyle = contourColor;
    ctx.lineWidth = contourWidth;
    ctx.stroke(path);

    if (errList) {
      ctx.fillStyle = errorPointColor;

      for (var j = 0; j < errList.length; j++) {
        var ept = errList[j];
        var path = buildErrorPoint(ept, w * zoom, h * zoom, origin, scale);

        ctx.fill(path);
      }
    }

    return canvas;
  };

  var _drawKyubey = function (ctx, w, h) {
    var outerRadius = w / 7;
    var innerRadius = w / 12;
    var outerEyeColor = "rgb(255, 50, 80)";
    var innerEyeColor = "rgb(200, 50, 80)";
    //first eye
    var firstEyeX = w / 5;
    var firstEyeY = h / 2;
    var eyePath = new Path2D();
    eyePath.arc(firstEyeX, firstEyeY, outerRadius, 0, Math.PI * 2);
    ctx.fillStyle = outerEyeColor;
    ctx.fill(eyePath);
    ctx.strokeStyle = innerEyeColor;
    ctx.stroke(eyePath);
    var eyePath = new Path2D();
    eyePath.arc(firstEyeX, firstEyeY, innerRadius, 0, Math.PI * 2);
    ctx.fillStyle = innerEyeColor;
    ctx.fill(eyePath);
    var refRadius = w / 18;
    var dist = 0.707 * (outerRadius - refRadius);
    var firstEyeReflectionX = firstEyeX + dist;
    var firstEyeReflectionY = firstEyeY - dist;
    var eyePath = new Path2D();
    eyePath.arc(
      firstEyeReflectionX,
      firstEyeReflectionY,
      refRadius,
      0,
      Math.PI * 2
    );
    ctx.fillStyle = "white";
    ctx.fill(eyePath);
    //second eye
    var secEyeX = (4 * w) / 5;
    var secEyeY = h / 2;
    var eyePath = new Path2D();
    eyePath.arc(secEyeX, secEyeY, outerRadius, 0, Math.PI * 2);
    ctx.fillStyle = outerEyeColor;
    ctx.fill(eyePath);
    ctx.stroke(eyePath);
    var eyePath = new Path2D();
    eyePath.arc(secEyeX, secEyeY, innerRadius, 0, Math.PI * 2);
    ctx.fillStyle = innerEyeColor;
    ctx.fill(eyePath);
    var firstEyeReflectionX = secEyeX + dist;
    var firstEyeReflectionY = secEyeY - dist;
    var eyePath = new Path2D();
    eyePath.arc(
      firstEyeReflectionX,
      firstEyeReflectionY,
      refRadius,
      0,
      Math.PI * 2
    );
    ctx.fillStyle = "white";
    ctx.fill(eyePath);
    //mouth
    var mouthRadius = outerRadius / 2;
    var mouthY = 0.685 * h;
    var mouthX1 = w / 2 - mouthRadius * 0.707;
    var mouthX2 = w / 2 + mouthRadius * 0.707;
    var mouthPath = new Path2D();
    mouthPath.arc(mouthX1, mouthY, mouthRadius, Math.PI / 4, (3 * Math.PI) / 4);
    ctx.strokeStyle = "black";
    ctx.stroke(mouthPath);
    var mouthPath = new Path2D();
    mouthPath.arc(mouthX2, mouthY, mouthRadius, Math.PI / 4, (3 * Math.PI) / 4);
    ctx.stroke(mouthPath);
  };

  var getUnitModifier = function (length, unit) {
    var powerOfTen = Math.round(Math.log(length / unit) / Math.log(10));
    if (powerOfTen > 2) {
      var mod = powerOfTen - 2;
    } else if (powerOfTen < 1) {
      var mod = powerOfTen - 1;
    } else if (isNaN(powerOfTen)) {
      throw "NaN";
    } else {
      var mod = 0;
    }
    return mod;
  };

  var drawGripOnCanvas = function (canvas, scale, zoom, objectScale) {
    var h = canvas.height;
    var w = canvas.width;
    var unitW = (zoom * w) / (scale * objectScale);
    try {
      var modW = getUnitModifier(w, unitW);
    } catch (e) {
      return { modW: null, modH: null };
    }
    unitW *= Math.pow(10, modW);
    var unitH = (zoom * h) / (scale * objectScale);
    try {
      var modH = getUnitModifier(h, unitH);
    } catch (e) {
      return { modW: null, modH: null };
    }
    unitH *= Math.pow(10, modH);
    var ctx = canvas.getContext("2d");
    ctx.lineWidth = 0.1;
    var path = new Path2D();
    for (var i = 0; i < w; i += unitW) {
      path.moveTo(i, 0);
      path.lineTo(i, h);
    }
    for (var i = 0; i < h; i += unitH) {
      path.moveTo(0, i);
      path.lineTo(w, i);
    }
    ctx.stroke(path);
    return { modW: modW, modH: modH };
  };

  var computedSlice;
  var globalCanvasRedraw = function (
    slicedMesh,
    val,
    zoom,
    origin,
    scale,
    dx,
    dy,
    objectScale
  ) {
    var w = canvas.width;
    var h = canvas.height;
    var unitW = (zoom * w) / (scale * objectScale);
    console.log(unitW);
    if (unitW > 1000 * w && unitW != Infinity) {
      var newCanvas = document.createElement("canvas");

      newCanvas.width = w;
      newCanvas.height = h;
      var _ctx = newCanvas.getContext("2d");
      _drawKyubey(_ctx, w, h);
      var ctx = canvas.getContext("2d");

      ctx.clearRect(0, 0, canvas.height, canvas.width);
      ctx.drawImage(newCanvas, 0, 0);
      return;
    }
    var newOrigin = [
      origin[0] - (dx * scale) / w,
      origin[1] - (dy * scale) / h,
    ];
    var slice = slicedMesh.slices[val];
    var path = slicedMesh.paths[val];
    var errList = slicedMesh.errors[val];
    var newCanvas = buildSliceCanvas(
      slice,
      w,
      h,
      zoom,
      newOrigin,
      scale,
      errList,
      path
    );
    var mods = drawGripOnCanvas(newCanvas, scale, zoom, objectScale);
    computedSlice = newCanvas;
    var ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.height, canvas.width);
    ctx.drawImage(newCanvas, 0, 0);
    return mods;
  };

  var onlyRect = function (x, y, sx, sy) {
    var ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.height, canvas.width);
    ctx.drawImage(computedSlice, 0, 0);
    ctx.strokeRect(x, y, sx, sy);
  };

  return [globalCanvasRedraw, onlyRect];
};

var SculpteoSlicer = function (canvas, unitWElement, unitHElement) {
  this.__init(canvas, unitWElement, unitHElement);
};

SculpteoSlicer.prototype.__init = function (
  canvas,
  unitWElement,
  unitHElement
) {
  var funcs = SculpteoSlicerRedraw(
    canvas,
    "red",
    "black",
    2,
    "green",
    1,
    "blue"
  );
  var redraw = funcs[0];
  var redrawRect = funcs[1];
  var _this = this;
  this.onlyRect = redrawRect;
  this.unitWElement = unitWElement;
  this.unitHElement = unitHElement;

  this.refresh = function (sliceIndex, zoom, dx, dy, objectScale) {
    if (!_this.slicedMesh || sliceIndex >= _this.getSliceNumber) {
      return;
    }

    //dx *= _this.scale/10;
    //dy *= _this.scale/10;
    var mods = redraw(
      _this.slicedMesh,
      sliceIndex,
      zoom,
      _this.origin,
      _this.scale,
      dx,
      dy,
      objectScale
    );
    _this.changeUnits(mods);
  };
};

SculpteoSlicer.prototype.changeUnits = function (mods) {
  console.log([this.unitWElement, this.unitHElement]);
  console.log(mods);
  if (this.unitWElement && mods.modW != null && mods.modW < 7) {
    this.unitWElement.text(Math.pow(10, mods.modW) + "mm");
  }
  if (this.unitHElement && mods.modH != null && mods.modH < 7) {
    this.unitHElement.text(Math.pow(10, mods.modH) + "mm");
  }
};

SculpteoSlicer.prototype.init = function (mesh, bbox) {
  this.slicedMesh = {};
  this.slicedMesh.bbox = bbox;
  this.slicedMesh.errors = mesh.errors;
  this.slicedMesh.slices = mesh.slices;
  this.slicedMesh.paths = mesh.paths;
  console.log(this.slicedMesh);
  this.scale = Math.max(bbox[1][0] - bbox[0][0], bbox[1][1] - bbox[0][1]);
  this.origin = [bbox[0][0], bbox[0][1]];
};

SculpteoSlicer.prototype.getSliceNumber = function () {
  return this.slicedMesh.slices.length;
};

var SculpteoSlicerUICstnts = {};

SculpteoSlicerUICstnts.containerWidth = 60;
SculpteoSlicerUICstnts.buttonHeight = 20;
SculpteoSlicerUICstnts.buttonWidth = 20;
SculpteoSlicerUICstnts.getHtml = function (w, h) {
  if ($(".slicer_container").length == 0) {
    var disp = " style='display: flex;'>";
  } else {
    var disp = ">";
  }
  var arr = [
    "<div" + disp,
    '<canvas id="slicer-canvas" style="border: black 1px solid;display: inline-block"></canvas>',
    '<div class="slicer_controls" style="display: inline-block;width: ',
    SculpteoSlicerUICstnts.containerWidth,
    "px;height: ",
    h,
    'px">',
    '<input id="index" type=text disabled="disabled" style="display: block;width: 100%;"></input>',
    '<button id="upbtn" style="display: block; width: ',
    SculpteoSlicerUICstnts.buttonWidth,
    "px;height: ",
    SculpteoSlicerUICstnts.buttonHeight,
    'px"></button>',
    '<input id="slider" type=range step=1 class="slicer" style="display: block; margin: 0;width: ',
    SculpteoSlicerUICstnts.buttonWidth,
    "px;height: ",
    h - 2 * SculpteoSlicerUICstnts.buttonHeight,
    "px;",
    "-webkit-appearance: slider-vertical;writing-mode: bt-lr;",
    '" orient=vertical></input>',
    '<button id="downbtn" style="width: ',
    SculpteoSlicerUICstnts.buttonWidth,
    "px;height: ",
    SculpteoSlicerUICstnts.buttonHeight,
    'px;display: block;"></button>',
    "</div>",
    "</div>",
    '<div id="sel-rect"></div>',
  ];

  return arr.join("");
};

SculpteoSlicerUICstnts.slicing = gettext("Slicing please wait");

SculpteoSlicer.holdRectKey = false;
$(document).on("keydown mousedown", function (e) {
  if (e.keyCode == 82 || e.which === 3) {
    SculpteoSlicerUI.holdRectKey = true;
  }
  if (e.keyCode == 69 && SculpteoSlicerUI.resetView) {
    SculpteoSlicerUI.resetView();
  }
  if (e.keyCode == 84 && SculpteoSlicerUI.popView) {
    SculpteoSlicerUI.popView();
  }
});
$(document).on("keyup mouseup", function (e) {
  if (e.keyCode == 82 || e.which === 3) {
    SculpteoSlicerUI.holdRectKey = false;
  }
});

var SculpteoSlicerUI = function (
  htmlElementId,
  w,
  h,
  slicerLoader,
  unitWElement,
  unitHElement
) {
  this.slicerLoader = slicerLoader;
  this.root = $("#" + htmlElementId);
  this.html = $(SculpteoSlicerUICstnts.getHtml(w, h));
  this.canvas = $("#slicer-canvas", this.html);
  this.canvas[0].width = w;
  this.canvas[0].height = h;
  this.slider = $("#slider", this.html);
  this.upBtn = $("#upbtn", this.html);
  this.downBtn = $("#downbtn", this.html);
  this.indexInput = $("#index", this.html);
  this.html.appendTo(this.root);
  var _this = this;
  var slider = this.slider;
  var canvas = this.canvas;
  var boxCommand = [];

  this.slicer = new SculpteoSlicer(canvas[0], unitWElement, unitHElement);
  var slicer = this.slicer;

  _this.index = 0;
  _this.zoom = 1.0;
  _this.dx = 0;
  _this.dy = 0;
  slider.on("mousedown", function () {
    slider.dragging = true;
  });

  slider.on("mouseup", function () {
    slider.dragging = false;
  });

  var prevPos = [0, h, w, h];
  this.zoomInBox = function (ox, oy, sx, sy) {
    boxCommand.push(prevPos);
    prevPos = [ox, oy, sx, sy];
    var zoomx = w / sx;
    var zoomy = h / sy;
    var zoom = Math.min(zoomx, zoomy);
    _this.dx = -ox;
    _this.dy = -(h / zoom - oy);
    _this.zoom = zoom;
    slicer.refresh(_this.index, zoom, _this.dx, _this.dy, _this.scale);
  };

  this.statefulZoomInBox = function (ox, oy, sx, sy) {
    //console.log("[" + ox + ", " + oy + ", " + sx + ", " + sy + "]");
    _this.zoomInBox(
      -_this.dx + ox / _this.zoom,
      _this.dy + oy / _this.zoom,
      sx / _this.zoom,
      sy / _this.zoom
    );
  };

  this.popZoomInBox = function () {
    if (boxCommand.length > 0) {
      var pos = boxCommand.pop();
      prevPos = boxCommand.pop();
      _this.zoomInBox(pos[0], pos[1], pos[2], pos[3]);
    }
  };
  SculpteoSlicerUI.popView = this.popZoomInBox;

  this.resetView = function () {
    _this.zoomInBox(0, h, w, h);
  };
  SculpteoSlicerUI.resetView = this.resetView;

  slider.on("mousemove change", function (e) {
    if (!slider.dragging && e.type !== "change") {
      return;
    }

    var val = parseInt(slider.val(), 10);

    slicer.refresh(val, _this.zoom, _this.dx, _this.dy, _this.scale);
    _this.index = val;
    _this.indexInput.val(_this.index);
  });

  canvas.on("wheel", function (event) {
    event.preventDefault();

    if (event.originalEvent.deltaY < 0) {
      _this.zoom += 0.1;
    } else {
      _this.zoom -= 0.1;
    }

    slicer.refresh(_this.index, _this.zoom, _this.dx, _this.dy, _this.scale);
  });

  canvas.on("mousedown", function (event) {
    console.log(event);
    canvas.dragging = true;
    this._orig_x = event.pageX;
    this._orig_y = event.pageY;
    _this._dx = _this.dx;
    _this._dy = _this.dy;
  });

  var getZoomBox = function (event) {
    var canvas_ = canvas[0];
    var rect = canvas_.getBoundingClientRect();
    var topx = rect.left + window.scrollX;
    var topy = rect.top + window.scrollY;
    var ox = canvas_._orig_x;
    var oy = Math.max(canvas_._orig_y, event.pageY);
    var sx = event.pageX - canvas_._orig_x;
    if (sx < 0) {
      ox = ox + sx;
    }
    var sy = event.pageY - canvas_._orig_y;
    //if(sy < 0){
    //oy = oy + sy;
    //}
    return [ox - topx, oy - topy, Math.abs(sx), Math.abs(sy)];
  };

  canvas.on("mouseup", function (event) {
    canvas.dragging = false;
    if (SculpteoSlicerUI.holdRectKey) {
      SculpteoSlicerUI.holdRectKey = false;
      var box = getZoomBox(event);
      _this.statefulZoomInBox(box[0], box[1], box[2], box[3]);
    }
  });

  canvas.on("mousemove", function (event) {
    if (!canvas.dragging) {
      return;
    }
    if (SculpteoSlicerUI.holdRectKey) {
      var box = getZoomBox(event);
      //var s = Math.max(box[2], box[3]);
      //slicer.onlyRect(box[0], box[1], s, -s);
      slicer.onlyRect(box[0], box[1], box[2], -box[3]);
      return;
    }

    var dx = event.pageX - this._orig_x;
    var dy = event.pageY - this._orig_y;

    _this.dx = dx + _this._dx;

    // Inverted commands for top left origin
    _this.dy = -dy + _this._dy;
    slicer.refresh(_this.index, _this.zoom, _this.dx, _this.dy, _this.scale);
  });

  this.upBtn.on("click", function () {
    _this.index = (_this.index + 1) % _this.slicer.getSliceNumber();
    slider.val(_this.index);
    slicer.refresh(_this.index, _this.zoom, _this.dx, _this.dy, _this.scale);
    _this.indexInput.val(_this.index);
  });

  this.downBtn.on("click", function () {
    _this.index = (_this.index - 1) % _this.slicer.getSliceNumber();
    slider.val(_this.index);
    slicer.refresh(_this.index, _this.zoom, _this.dx, _this.dy, _this.scale);
    _this.indexInput.val(_this.index);
  });

  this.onProgress = function (len, tot) {
    console.log(len + "/" + tot);
  };
};

SculpteoSlicerUI.prototype.init = function (design_uuid, scale, step) {
  this.design_uuid = design_uuid;
  this.scale = scale;
  this.step = step;
  this.old_data = undefined;
};

SculpteoSlicerUI.prototype.setUUID = function (uuid) {
  this.design_uuid = uuid;
};

SculpteoSlicerUI.prototype.toRefresh = function (data) {
  if (!this.old_data) {
    return true;
  } else {
    return (
      data.qw != this.old_data.qw ||
      data.qx != this.old_data.qx ||
      data.qy != this.old_data.qy ||
      data.qz != this.old_data.qz ||
      data.tempering != this.old_data.tempering ||
      data.no_merge != this.old_data.no_merge ||
      data.zom != this.old_data.zom ||
      data.zov != this.old_data.zov
    );
  }
};

SculpteoSlicerUI.prototype.showLoader = function () {
  if (this.slicerLoader) {
    console.log(this.slicerLoader);
    this.slicerLoader.css("display", "block");
  }
};

SculpteoSlicerUI.prototype.hideLoader = function () {
  if (this.slicerLoader) {
    this.slicerLoader.css("display", "None");
  }
};

SculpteoSlicerUI.prototype.refreshModel = function (
  quat,
  tempering,
  base_thickened,
  extra,
  backend,
  z_offset_method,
  z_offset_value
) {
  this.index = 0;
  this.dragging = false;
  this.zoom = 1.0;
  this.dx = 0;
  this.dy = 0;
  var _this = this;
  var data = {
    step: _this.step / _this.scale,
    qw: quat[0],
    qx: quat[1],
    qy: quat[2],
    qz: quat[3],
    tempering: tempering,
    no_merge: base_thickened,
    zom: z_offset_method,
    zov: z_offset_value / _this.scale,
  };

  $.extend(data, extra);

  if (this.toRefresh(data)) {
    this.old_data = data;
  } else {
    return;
  }

  if (this.req) {
    this.req.abort();
  }

  this.showLoader();

  if (this.onRequest) {
    this.onRequest(SculpteoSlicerUICstnts.slicing);
  }

  // use the backend URL if we're on backend; otherwise, hit the design API
  var url = "";
  if (backend) {
    data["backend"] = true;
    url = URLS["backend_slice_mesh"] + _this.design_uuid;
  } else {
    url = URLS["design_slice_mesh"] + _this.design_uuid;
  }

  waitForJob
    .retryAjaxOnJob({
      url: url,
      data: data,
      async: true,
      xhr: function () {
        var xhr = new window.XMLHttpRequest();
        _this.req = xhr;

        xhr.addEventListener(
          "progress",
          function (evt) {
            if (!_this.onProgress) {
              return;
            }

            if (evt.lengthComputable) {
              _this.onProgress(evt.loaded, evt.total);
            } else {
              var total = xhr.getResponseHeader("X-content-length");

              _this.onProgress(evt.loaded, total);
            }
          },
          false
        );

        return xhr;
      },
      dataFilter: function (data, type) {
        // this can be either a mesh or json
        // trying to parse json if not it is a
        // mesh then
        try {
          return JSON.parse(data);
        } catch (e) {
          return data;
        }
      },

      beforeSend: function (xhr) {
        xhr.overrideMimeType("text/plain; charset=x-user-defined");
      },
    })
    .done(function (data, textStatus, request) {
      var bbox = JSON.parse(request.getResponseHeader("X-Sculpteo-BBox"));
      var header_failure = request.getResponseHeader("X-failure-cause");
      if (header_failure) {
        window.alert(header_failure);
      }
      var mesh = new Mesh(new BinaryReaderString(request.responseText));

      mesh.decodeSlice(function () {
        _this.slicer.init(mesh, bbox);
        var slider = _this.slider;

        slider[0].min = 0;
        slider[0].max = _this.slicer.getSliceNumber() - 1;
        slider[0].value = _this.index;
        _this.slicer.refresh(
          _this.index,
          _this.zoom,
          _this.dx,
          _this.dy,
          _this.scale
        );
        _this.indexInput.val(_this.index);
        _this.hideLoader();
      });
    });
};

var ProgressBar = function (root) {
  this.init(root);
};

ProgressBar.html =
  '<div id="slicing_request" style="padding: 5px;">' +
  '<div class="bgwhite innershadow" id="base-slicing-progress" style="display:inline-block;height: 20px;width: 200px;">' +
  '<span id="slicing-progress"  style="width: 0%;height:100%;display:inline-block;background-color: rgb(0,0,200)"></span>' +
  "</div>" +
  '<label id="slicing-info" style="display:inline-block;"></label>' +
  "</div>";

ProgressBar.prototype.init = function (root) {
  this.root = root;
  this.progressBar = $(ProgressBar.html);
  this.progressBar.appendTo(root);
  this.progress = $("#slicing-progress", this.progressBar);
  this.label = $("#slicing-info", this.progressBar);
};

ProgressBar.prototype.getUpdateFunc = function () {
  var _this = this;
  var divider = function (len, tot) {
    _this.progress.width((len / tot) * 100 + "%");
    _this.label.text(len + "/" + tot);
  };

  return divider;
};

ProgressBar.prototype.getInitFunc = function () {
  var _this = this;
  var reset = function (text) {
    _this.progress.width("0%");
    _this.label.text(text);
  };

  return reset;
};
